import type { InjectionKey } from "vue";

export const WindowKey: InjectionKey<Window & typeof globalThis> =
  Symbol("window");
